import { StateVariablesDTOWrapper } from '../../shared/DTO/StateVariablesDTO';

export class StateVariables {
  constructor(
    private hardwareToPlatformMap: Map<string, string>,
    private platformToHardwareMap: Map<string, string>) { }

  static fromDTOWrapper(stateVariablesDTOWrapper: StateVariablesDTOWrapper): StateVariables {
    const hardwareToPlatformMap = new Map();
    const platformToHardwareMap = new Map();
    if (stateVariablesDTOWrapper && stateVariablesDTOWrapper.moduleStateVariables) {
      stateVariablesDTOWrapper.moduleStateVariables.forEach(device => {
        hardwareToPlatformMap.set(device.hardwareName, device.platformName);
        platformToHardwareMap.set(device.platformName, device.hardwareName);
      });
    }
    return new StateVariables(hardwareToPlatformMap, platformToHardwareMap);
  }

  hardwareToPlatform(hardwareKey: string): string {
    return this.hardwareToPlatformMap.get(hardwareKey);
  }

  platformToHardware(platformKey: string): string {
    return this.platformToHardwareMap.get(platformKey);
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/state-variables.model.ts